import { buildClientSummaryTotals, normalizeClientSummaryItems, minutesToHuman, numBR } from './summaryClientDomain';

export const buildSummaryClientViewModel = (items, timezone, prebuiltRows = null) => {
  const rows = prebuiltRows || normalizeClientSummaryItems(items, timezone);
  const totals = buildClientSummaryTotals(rows);

  return {
    rows,
    cards: [
      { label: 'Total de veículos', value: String(totals.total) },
      { label: 'Distância total', value: `${numBR(totals.totalKm)} km` },
      { label: 'Total de viagens', value: String(totals.totalTrips) },
      { label: 'Tempo total em movimento', value: minutesToHuman(totals.totalMovMin) },
      { label: 'Tempo total de motor ligado', value: minutesToHuman(totals.totalMotorMin) },
      { label: 'Veículos sem deslocamento', value: String(totals.semDeslocamento) },
    ],
  };
};
